
export default {
  props: {
    to: String,
    text: { default: "تعديل", type: String },
    color: { default: "success", type: String },
  },
};
